import WeeklyReport from './WeeklyReport.vue'

export default WeeklyReport
